//Для подгрузки иконок файлов (Что-то страшное получилось, но не понятно как много svg за раз грузить)
//Чтобы добавть новую иконку, нужно:
// 1. загрузить svg в "../../../assets/FileIcons/xsl.svg"
// 2. Добавить импорт ниже
// 3. Добавить переменную из импорта в fileIcons

import xsl_svg from "../assets/FileIcons/xsl.svg";
import xls_svg from "../assets/FileIcons/xsl.svg";
import xlsx_svg from "../assets/FileIcons/xsl.svg";

import avi_svg from "../assets/FileIcons/avi.svg";
import bmp_svg from "../assets/FileIcons/bmp.svg";
import crd_svg from "../assets/FileIcons/crd.svg";
import csv_svg from "../assets/FileIcons/csv.svg";
import dll_svg from "../assets/FileIcons/dll.svg";
import doc_svg from "../assets/FileIcons/doc.svg";
import docx_svg from "../assets/FileIcons/docx.svg";
import dwg_svg from "../assets/FileIcons/dwg.svg";
import eps_svg from "../assets/FileIcons/eps.svg";
import exe_svg from "../assets/FileIcons/exe.svg";
import flv_svg from "../assets/FileIcons/flv.svg";
import gif_svg from "../assets/FileIcons/gif.svg";
import html_svg from "../assets/FileIcons/html.svg";
import iso_svg from "../assets/FileIcons/iso.svg";
import java_svg from "../assets/FileIcons/java.svg";
import jpg_svg from "../assets/FileIcons/jpg.svg";
import mdb_svg from "../assets/FileIcons/mdb.svg";
import mid_svg from "../assets/FileIcons/mid.svg";
import mov_svg from "../assets/FileIcons/mov.svg";
import mp3_svg from "../assets/FileIcons/mp3.svg";
import mp4_svg from "../assets/FileIcons/mp4.svg";
import mpeg_svg from "../assets/FileIcons/mpeg.svg";
import pdf_svg from "../assets/FileIcons/pdf.svg";
import png_svg from "../assets/FileIcons/png.svg";
import ppt_svg from "../assets/FileIcons/ppt.svg";
import pptx_svg from "../assets/FileIcons/ppt.svg";
import ps_svg from "../assets/FileIcons/ps.svg";
import psd_svg from "../assets/FileIcons/psd.svg";
import pub_svg from "../assets/FileIcons/pub.svg";
import rar_svg from "../assets/FileIcons/rar.svg";
import raw_svg from "../assets/FileIcons/raw.svg";
import rss_svg from "../assets/FileIcons/rss.svg";
import svg_svg from "../assets/FileIcons/svg.svg";
import tiff_svg from "../assets/FileIcons/tiff.svg";
import txt_svg from "../assets/FileIcons/txt.svg";
import json_svg from "../assets/FileIcons/txt.svg";
import wav_svg from "../assets/FileIcons/wav.svg";
import wma_svg from "../assets/FileIcons/wma.svg";
import xml_svg from "../assets/FileIcons/xml.svg";
import zip_svg from "../assets/FileIcons/zip.svg";

export type FileIconType = 
  | 'xsl' | 'xls' | 'xlsx' | 'avi' | 'bmp' | 'crd' | 'csv' | 'dll' 
  | 'doc' | 'docx' | 'dwg' | 'eps' | 'exe' | 'flv' | 'gif' | 'html' 
  | 'iso' | 'java' | 'jpg' | 'mdb' | 'mid' | 'mov' | 'mp3' | 'mp4' 
  | 'mpeg' | 'pdf' | 'png' | 'ppt' | 'pptx' | 'ps' | 'psd' | 'pub' 
  | 'rar' | 'raw' | 'rss' | 'svg' | 'tiff' | 'txt' | 'json' | 'wav' 
  | 'wma' | 'xml' | 'zip';

// Типизированный объект с иконками
export const FILE_ICON: Record<FileIconType, string> = {
  xsl: xsl_svg,
  xls: xls_svg,
  xlsx: xlsx_svg,
  avi: avi_svg,
  bmp: bmp_svg,
  crd: crd_svg,
  csv: csv_svg,
  dll: dll_svg,
  doc: doc_svg,
  docx: docx_svg,
  dwg: dwg_svg,
  eps: eps_svg,
  exe: exe_svg,
  flv: flv_svg,
  gif: gif_svg,
  html: html_svg,
  iso: iso_svg,
  java: java_svg,
  jpg: jpg_svg,
  mdb: mdb_svg,
  mid: mid_svg,
  mov: mov_svg,
  mp3: mp3_svg,
  mp4: mp4_svg,
  mpeg: mpeg_svg,
  pdf: pdf_svg,
  png: png_svg,
  ppt: ppt_svg,
  pptx: pptx_svg,
  ps: ps_svg,
  psd: psd_svg,
  pub: pub_svg,
  rar: rar_svg,
  raw: raw_svg,
  rss: rss_svg,
  svg: svg_svg,
  tiff: tiff_svg,
  txt: txt_svg,
  json: json_svg,
  wav: wav_svg,
  wma: wma_svg,
  xml: xml_svg,
  zip: zip_svg,
};